import state from './state'
import * as actions from './actions'
import * as getters from './getters'
import mutations from './mutations'
import abFeatures from './modules/abFeatures'
import iaPromo from './modules/iaPromo'
import ibcust from './modules/ibcust'
import options from './modules/options'
import am from './modules/am'
import ira from './modules/ira'
import mdfarm from './modules/mdfarm'
import iserverData from './modules/iserver'
import fyi from './modules/fyi'
import pa from './modules/pa'
import folio from './modules/folio'
import portfolio from './modules/portfolio'
import wideScreen from './modules/wideScreen'
import scanner from './modules/scanner'

export default store => {
    if (!store._modules.root._children.abFeatures) {
        store.registerModule('abFeatures', abFeatures);
    }
    if (!store._modules.root._children.iaPromo) {
        store.registerModule('iaPromo', iaPromo);
    }
    if (!store._modules.root._children.options) {
        store.registerModule('options', options);
    }
    if (!store._modules.root._children.ibcust) {
        store.registerModule('ibcust', ibcust);
    }
    if (!store._modules.root._children.am) {
        store.registerModule('am', am);
    }
    if (!store._modules.root._children.ira) {
        store.registerModule('ira', ira);
    }
    if (!store._modules.root._children.mdfarm) {
        store.registerModule('mdfarm', mdfarm);
    }
    if (!store._modules.root._children.iserverData) {
        store.registerModule('iserverData', iserverData);
    }
    if (!store._modules.root._children.fyi) {
        store.registerModule('fyi', fyi);
    }
    if (!store._modules.root._children.pa) {
        store.registerModule('pa', pa);
    }
    if (!store._modules.root._children.folio) {
        store.registerModule('folio', folio);
    }
    if (!store._modules.root._children.portfolio) {
        store.registerModule('portfolio', portfolio);
    }
    if (!store._modules.root._children.common) {
        store.registerModule('common', {
            strict: $build.mode != 'production',
            state,
            getters,
            actions,
            mutations
        });
    }
    if (!store._modules.root._children.wideScreen) {
        store.registerModule('wideScreen', wideScreen);
    }
    if (!store._modules.root._children.scanner) {
        store.registerModule('scanner', scanner);
    }
};
